var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCenarioErrorTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 287,
    viewBox: "0 0 356 287",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M513.543 -231.289C513.543 -231.289 328.303 -321.059 221.893 -285.789C115.483 -250.519 9.07297 46.0411 9.07297 46.0411C9.07297 46.0411 -27.927 141.481 47.513 215.451C79.393 246.691 124.853 266.701 174.223 272.611C261.433 283.041 461.543 301.701 513.543 260.751V-231.289Z",
    fill: "url(#paint0_linear_1265_153)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M204.729 194.168C206.789 207.262 219.073 216.206 232.167 214.147C245.261 212.087 254.206 199.802 252.146 186.708C250.086 173.615 237.801 164.67 224.708 166.73C211.614 168.79 202.669 181.074 204.729 194.168Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7289 49.1678C89.7887 62.2616 102.073 71.2064 115.167 69.1465C128.261 67.0867 137.206 54.8022 135.146 41.7084C133.086 28.6146 120.801 19.6698 107.708 21.7297C94.6138 23.7896 85.669 36.074 87.7289 49.1678Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M260.338 225.91C261.368 232.457 267.51 236.929 274.057 235.899C280.604 234.87 285.076 228.727 284.046 222.18C283.017 215.633 276.874 211.161 270.327 212.191C263.781 213.221 259.308 219.363 260.338 225.91Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M265.41 174.499C266.869 183.774 275.571 190.11 284.846 188.651C294.121 187.192 300.456 178.49 298.997 169.215C297.538 159.941 288.837 153.605 279.562 155.064C270.287 156.523 263.951 165.224 265.41 174.499Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M298.397 216.887C299.169 221.797 303.776 225.152 308.686 224.379C313.596 223.607 316.95 219 316.178 214.09C315.405 209.18 310.799 205.825 305.889 206.598C300.978 207.37 297.624 211.977 298.397 216.887Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.399 52.1098C155.171 57.02 159.778 60.3743 164.688 59.6018C169.598 58.8294 172.952 54.2227 172.18 49.3125C171.407 44.4024 166.801 41.0481 161.891 41.8205C156.98 42.593 153.626 47.1996 154.399 52.1098Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1265_153",
    x1: -115,
    y1: 158,
    x2: 470,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F8ECC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972916,
    stopColor: "#2980B9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenarioErrorTop);
export default __webpack_public_path__ + "static/media/CenarioErrorTop.d4d6aba69b111a492e5ba6e99ab64495.svg";
export { ForwardRef as ReactComponent };